// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const HeaderContainer = styled.div`
  padding: 0 32px;
`;

const PageTitle = styled.h1`
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px
  color: ${({ theme }) => theme.colors.neutralBlack};
  margin-bottom: 6px;
`;

const PageDescription = styled.p`
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.neutralBlack};
  
  a {
    color: ${({ theme }) => theme.colors.lighterBlue};
    text-decoration: underline;

    &:hover {
      color: ${({ theme }) => theme.colors.deepIndigo};
      font-weight: 700;
    }
  }
`;

const Divider = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.colors.lightGray};
`;

type Props = {
  title: string;
  description: string;
  linkText?: string;
  linkTo?: string;
};

const PageHeader: React.FC<Props> = ({ 
  title, 
  description, 
  linkText, 
  linkTo 
}) => {
  return (
    <HeaderContainer>
      <PageTitle>{title}</PageTitle>
      <PageDescription>
        {description}
        {linkText && linkTo && (
          <>
            {' '}
            <Link target="_blank" to={linkTo}>{linkText}</Link>
          </>
        )}
      </PageDescription>
      <Divider />
    </HeaderContainer>
  );
};

export default React.memo(PageHeader);
